import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { DataPrivacyInfoTypeRepoService } from '../../services/api/info-type/data-privacy-info-type-repo.service';
import { MonDialog } from '@client/app/modules/dialog-upgrade-wrapper/mon-dialog.service';
import { DataPrivacyService } from '../../services/data-privacy/data-privacy.service';
import { MonModalService } from '@client/app/modules/modals/services/mon-modal/mon-modal.service';
import { DomainRepoService } from '@client/app/services/api/domain-repo/domain-repo.service';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import { INFOTYPE_GROUPS } from '@client/app/modules/data-privacy/constants/infotype-groups.constant';
import { default as REGIONS } from 'app/modules/data-privacy/constants/regions.constant.json';
import { activeFeatures } from '@monsido/core/constants/general.constant';
import { REGULATIONS } from '@client/app/modules/data-privacy/constants/regulations.constant';
import { MON_EVENTS } from '@monsido/core/constants/mon-events.constant';
import { mergeDeep, deepEqual } from '@client/app/shared/utils/object-utils';
import { FormUtils } from '@client/ng2/shared/form-utils';
import {
    PrivacyDialogsHelpCenterComponent,
} from '@client/app/modules/data-privacy/dialogs/help-center/help-center.component';
import { NgForm } from '@angular/forms';
import { BaseContainerComponentController } from '@client/app/blocks/base/base.controller';

@Component({
    selector: 'domain-data-privacy-settings',
    template: `
        <div id="domain-settings-data-policy" class="data-privacy">
            <form #dpmForm="ngForm" class="form-data-privacy-domain-settings form-horizontal" (ngSubmit)="dpmForm.valid && submit($event)">
                <div class="mon-dialog-header">
                    <page-header header="{{ 'Data privacy domain settings' | translate }}" panelLeftClass="col-48 mt-2">
                    </page-header>
                </div>
                <div class="mon-dialog-body-with-footer bg-body inner-t-medium">
                    <div>
                        <div class="bg-white m-3 mt-0 panel-monsido-card">
                            <div class="card-header mb-4">
                                <page-header
                                        header="{{'Choose What to Scan' | translate}}"
                                        subHeader="{{ 'Choose an existing data law to be the default template for your security scan. Edit the issues below to exclude certain tags from being scanned' | translate}}"
                                        panelClass="m-0">
                                </page-header>
                            </div>
                            <div class="card-body pt-0">
                                <div class="inline-block col-9 p-0" *ngFor="let regulation of regulations">
                                    <div class="d-inline-block v-align-middle">
                                        <label for="{{regulation.name}}" class="inline ml-2">
                                            {{regulation.name | translate }}
                                        </label>
                                        <span class="outer-l-smurf fas fa-question-circle mr-2" [ngbTooltip]="regulation.full_name" placement="top-left" [triggers]="'focus hover'"></span>
                                    </div>
                                    <div class="d-inline-block v-align-middle">
                                        <form-field-material-switch
                                                [(ngModel)]="selectedRegulations[regulation.name]"
                                                [name]="regulation.name"
                                                monEventTrigger="actionTrigger"
                                                [monEventParams]="{action: 'data-privacy-settings-regulation-checkbox', params: {regulation: regulation.name}}"
                                                (click)="toggleRegulation(regulation)">
                                        </form-field-material-switch>
                                    </div>
                                </div>
                                <table-container noResultMessage="{{ 'Good job! No violations were found' | translate }}"
                                                 [collection]="filteredPages"
                                                 [disablePagination]="true"
                                                 [progress]="progress"
                                                 class="pages-table-wrapper"
                                >
                                    <table-container-top>
                                        <mon-tabs
                                                [options]="tabs"
                                                [(status)]="activeTab"
                                                (onStatus)="onStatus($event)"
                                                (onSearch)="onSearchChange($event)"
                                                [search]="search"
                                                [minSearchLength]="1"
                                                [showFiltersBtn]="showFilters"
                                                [(isFiltersOpen)]="isFiltersOpen"
                                                [showSearch]="true">
                                        </mon-tabs>
                                        <div class="outer-b merge-t-10" *ngIf="isFiltersOpen">
                                            <table-filters [(open)]="isFiltersOpen"
                                                           [(ngModel)]="filters"
                                                           name="tableFilters"
                                                           [filters]="availableFilters"
                                                           (onChanges)="onFiltersChanges($event)">
                                            </table-filters>
                                        </div>
                                    </table-container-top>
                                    <table class="table table-hover">
                                        <thead>
                                        <tr>
                                            <th monTableSort
                                                monSortBy="group"
                                                [monSortDirection]="currentSort.direction"
                                                [monCurrentlySortedBy]="currentSort.by"
                                                (monOnSorted)="onMonTableSort($event)"
                                                class="col-3 type-cell text-left text-v-middle">
                                                {{ 'Type' | translate }}
                                            </th>
                                            <th monTableSort
                                                monSortBy="name"
                                                [monSortDirection]="currentSort.direction"
                                                [monCurrentlySortedBy]="currentSort.by"
                                                (monOnSorted)="onMonTableSort($event)"
                                                class="text-left text-v-middle">
                                                {{ 'Issue name' | translate }}
                                            </th>

                                            <th class="text-left text-v-middle">
                                                {{ 'Regulation' | translate }}
                                            </th>
                                            <th class="text-right text-v-middle"
                                                translate>
                                                Help center
                                            </th>

                                            <th monTableSort
                                                monSortBy="priority"
                                                [monSortDirection]="currentSort.direction"
                                                [monCurrentlySortedBy]="currentSort.by"
                                                (monOnSorted)="onMonTableSort($event)"
                                                class="text-right text-v-middle">
                                                {{ 'Severity' | translate }}
                                            </th>
                                            <th class="text-right text-v-middle"></th>
                                        </tr>
                                        </thead>
                                        <tbody *ngFor="let pages of filteredPages; let index = index">
                                        <tr [ngClass]="['regionBar', pages.name]" *ngIf="pages.pages.length > 0">
                                            <td colspan="5">{{formatText(pages.name)}}</td>
                                            <td class="text-right text-v-middle">
                                                <input type="checkbox" [(ngModel)]="pages.selectAll" (change)="toggleRegion(pages)" [name]="'pagesRegion' + index">
                                            </td>
                                        </tr>
                                        <ng-container *ngFor="let infoType of pages.pages">
                                            <tr *ngIf="pages.pages.length > 0" (click)="toggleExtraExclude(infoType, pages)">
                                            <td class="col-3 type-cell text-left text-v-middle" [ngClass]="{'disabled': infoType.enabled === false}">
                                                <mon-data-privacy-info-type-icon [monGroup]="infoType.group"
                                                                                 [monPriority]="infoType.priority"
                                                                                 monTooltipText="{{ formatText(infoType.group || 'other') | translate }}">
                                                </mon-data-privacy-info-type-icon>
                                            </td>
                                            <td class="text-left text-v-middle" [ngClass]="{'disabled': infoType.enabled === false}">
                                                {{infoType.name}}
                                            </td>
                                            <td class="text-left text-v-middle" [ngClass]="{'disabled': infoType.enabled === false}">
                                                {{ infoType.regulations.join(', ') }}
                                            </td>
                                            <td class="text-right text-v-middle">
                                            <span (click)="openHelpCenter(infoType)"
                                                  role="button"
                                                  [attr.aria-label]="'Go to help center' | translate"
                                                  monEventTrigger="actionTrigger"
                                                  [monEventParams]="{action: 'data-privacy-help-center-btn', params:{infoTypeId: infoType.id}}"
                                                  class="cursor-pointer text-link fas fa-graduation-cap"
                                                  tabindex="0">
                                            </span>
                                            </td>
                                            <td class="text-right text-v-middle">
                                                <mon-data-privacy-severity-level [monPriority]="infoType.priority" *ngIf="!loading" />
                                            </td>
                                            <td class="text-right text-v-middle">
                                                <input type="checkbox" [(ngModel)]="infoType.enabled" [name]="'infoTypeEnabled' + infoType.id">
                                            </td>
                                        </tr></ng-container>
                                        </tbody>
                                    </table>
                                </table-container>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mon-dialog-footer text-right">
                    <button type="button"
                            class="btn btn-border-radius btn-secondary"
                            monEventTrigger="actionTrigger"
                            [monEventParams]="{action: 'reset-data-privacy-settings'}"
                            (click)="getPage()"
                            translate>
                        Reset Preferences
                    </button>
                    <button type="submit"
                            data-test="save-button"
                            class="btn btn-border-radius btn-primary"
                            monEventTrigger="actionTrigger"
                            [monEventParams]="{action: 'save-data-privacy-settings'}"
                            [disabled]="disabled || saving">
                        <span class="fa-spin fa-fw" [ngClass]="{'fas fa-spinner': saving}" aria-hidden="true"></span>
                        <span translate>
                            Save Preferences
                        </span>
                    </button>
                </div>
            </form>
        </div>
    `,
    standalone: false,
})

export class DomainDataPrivacySettingsComponent extends BaseContainerComponentController implements OnInit, AfterViewInit {
    @Input() domain: any;
    @Input() monDialogId: any;
    @Input() setForm: any;

    infoTypes: any;
    tabs: any;
    override filters: any;
    override availableFilters: any;
    override showFilters = false;
    override isFiltersOpen = false;
    filteredPages: any = [];
    regulations: any = [];
    selectedRegulations: any = [];
    saving = false;
    disabled = false;
    originalSelectedRegulations: any;
    @ViewChild('dpmForm') dpmForm?: NgForm;
    originalCustomRuleset: any;
    pageCount: any;
    progress: any;
    loading: any;

    constructor (
        private ng2DataPrivacyInfoTypeRepoService: DataPrivacyInfoTypeRepoService,
        private gettextCatalog: TranslateService,
        private monDialog: MonDialog,
        private ng2DataPrivacyService: DataPrivacyService,
        private ng2DomainRepoService: DomainRepoService,
        private ng2MonModalService: MonModalService,
        private ng2MonEventsService: MonEventService,
    ) {
        super({ table: true });
    }

    ngOnInit () {
        this.infoTypes = [];
        this.tabs = [
            {
                name: this.gettextCatalog.getString('All'),
                value: 'all',
            },
            {
                name: this.gettextCatalog.getString('High'),
                value: 'high',
            },
            {
                name: this.gettextCatalog.getString('Medium'),
                value: 'medium',
            },
            {
                name: this.gettextCatalog.getString('Low'),
                value: 'low',
            },
        ];
        this.activeTab = this.tabs[0].value;
        this.currentSort.by = 'name';
        this.currentSort.direction = 'desc';
        this.filters = { 'Issue type': [], Country: [] };
        this.availableFilters = {
            'Issue type': INFOTYPE_GROUPS,
            Country: REGIONS,
        };
        this.showFilters = activeFeatures.table_filters;
        this.isFiltersOpen = false;
        this.filteredPages = [];
        this.regulations = REGULATIONS;
        this.selectedRegulations = {
            GDPR: false,
            CCPA: false,
            APA: false,
            SHIELD: false,
            PIPEDA: false,
        };
        this.saving = false;
        this.disabled = true;

        this.getPage();
        this.originalSelectedRegulations = mergeDeep({}, this.selectedRegulations);
        this.originalCustomRuleset = mergeDeep({}, this.domain.settings.data_protection.custom_ruleset);

    }

    ngAfterViewInit () {
        this.setForm({ id: this.monDialogId, form: this.dpmForm });
    }

    override getPage = () => {
        const params: any = {};
        if (this.search) {
            params.search = this.search;
        }
        params.page = this.page;
        params.page_size = 999;
        params.sort_dir = this.currentSort.direction;
        params.sort_by = this.currentSort.by;
        if (this.activeTab !== 'all') {
            params.priority = this.activeTab;
        }
        params['type[]'] = this.filters['Issue type'].map((type) => {
            return type.value;
        });
        const promises: any = [this.ng2DataPrivacyInfoTypeRepoService.getAll(params)];
        if (this.domain.id > 0) {
            promises.push(this.ng2DomainRepoService.get(this.domain.id));
        }
        this.progress = Promise.all(promises).then((values) => {
            this.infoTypes = values[0];
            if (this.domain.id > 0) {
                this.domain = values[1];
            }
            this.domain.settings.data_protection.enabled_regulations.forEach((regulation) => {
                this.selectedRegulations[regulation] = true;
            });
            this.onFiltersChanges({ Country: REGIONS, 'Issue type': [] });
            this.updateRegulation();
            this.disabled = false;
        });
    };

    openHelpCenter (infoType) {
        const params = {
            size: 'lg',
            body: PrivacyDialogsHelpCenterComponent,
            data: { infoType: infoType },
        };

        this.ng2MonEventsService.run(MON_EVENTS.LOAD_DIALOG, { params });
    }

    onFiltersChanges (change, searchedInfoTypes?) {
        this.filteredPages = [];
        const infoTypeToUse = searchedInfoTypes || this.infoTypes;
        if (change.Country.length === 0) {
            return this.onFiltersChanges({ Country: REGIONS, 'Issue type': change['Issue type'] }, searchedInfoTypes);
        } else {
            change.Country.forEach((region) => {
                if (region.value !== 'global') {
                    this.filteredPages.push({
                        name: region.value,
                        selectAll: false,
                        pages: infoTypeToUse.filter((infoType) => {
                            return infoType.regions.indexOf(region.value) !== -1;
                        }),
                    });
                } else {
                    this.filteredPages.push({
                        name: region.value,
                        selectAll: false,
                        pages: infoTypeToUse.filter((infoType) => {
                            return infoType.regions.indexOf(region.value) !== -1 || infoType.regions.length === 0;
                        }),
                    });
                }
            });

            this.filteredPages.sort((a, b) => {
                if (a.name > b.name || (a.name === 'gobal' || b.name === 'global')) {
                    return 1;
                }
                if (a.name < b.name) {
                    return -1;
                }
                return 0;
            });
        }
        if (change['Issue type'].length > 0) {
            this.filteredPages.forEach((page) => {
                page.pages = page.pages.filter((o) => {
                    return change['Issue type'].some(typeFilter => typeFilter.value === o.group);
                });
            });
        }
    }

    onSearchChange (search) {
        let searchedInfoTypes = [];
        if (search === '') {
            searchedInfoTypes = this.infoTypes.slice();
        } else {
            searchedInfoTypes = this.infoTypes.filter((infoType) => {
                return infoType.name.toUpperCase().includes(search.toUpperCase());
            });
        }
        this.onFiltersChanges(this.filters, searchedInfoTypes);
    }

    toggleRegulation (regulation) {
        if (!deepEqual(this.originalSelectedRegulations, this.selectedRegulations)) {
            FormUtils.markFormAsDirty(this.dpmForm);
        }
        setTimeout(() => {
            const isRegulationSelected = this.selectedRegulations[regulation.name];
            const ruleset = this.getRuleset(regulation);
            let list = '<ul>';
            ruleset.forEach((id) => {
                list = list + '<li>' + this.infoTypes.find(infoType => infoType.id === id).name + '</li>';
            });
            list = list + '</ul>';
            if (ruleset.length > 0) {
                const msg = this.gettextCatalog.getString(
                    '[[msg]] <strong>[[regulationName]]</strong> will result in the custom [[opposite]] rules ' +
                    'for the following issues being overwritten, meaning they will [[negate]] be flagged by future scans: [[list]]',
                    {
                        msg: isRegulationSelected ? this.gettextCatalog.getString('Enabling') : this.gettextCatalog.getString('Disabling'),
                        opposite: isRegulationSelected ? this.gettextCatalog.getString('disabling') : this.gettextCatalog.getString('enabling'),
                        negate: isRegulationSelected ? '' : this.gettextCatalog.getString('not'),
                        regulationName: regulation.name,
                        list: list,
                    },
                );
                this.ng2MonModalService.confirm(msg).then(
                    () => {
                        FormUtils.markFormAsDirty(this.dpmForm);
                        this.updateRegulation(ruleset, regulation);
                    },
                    () => {
                        this.selectedRegulations[regulation.name] = !isRegulationSelected;
                    },
                );
            } else {
                FormUtils.markFormAsDirty(this.dpmForm);
                this.updateRegulation();
            }
        });
    }

    getRuleset (regulation) {
        let ruleset;
        if (this.selectedRegulations[regulation.name]) {
            ruleset = this.domain.settings.data_protection.custom_ruleset.exclusions.filter((id) => {
                return this.infoTypes.find(infoType => infoType.id === id && infoType.regulations.includes(regulation.name));
            });
        } else {
            ruleset = this.domain.settings.data_protection.custom_ruleset.extras.filter((id) => {
                return this.infoTypes.find(infoType => infoType.id === id && infoType.regulations.includes(regulation.name));
            });
        }
        return ruleset;
    }

    updateRegulation (toOverwrite?, regulation?) {
        // transform selected regulations map to array
        // need timeout to wait 1 extra cycle for ng-model to set value
        setTimeout(() => {
            this.domain.settings.data_protection.enabled_regulations = [];
            for (const key in this.selectedRegulations) {
                if (this.selectedRegulations.hasOwnProperty(key)) {
                    if (this.selectedRegulations[key]) {
                        this.domain.settings.data_protection.enabled_regulations.push(key);
                    }
                }
            }
            if (toOverwrite) {
                this.enableInfoTypes(toOverwrite, regulation);
            } else {
                this.enableInfoTypes();
            }
        });
    }

    enableInfoTypes (toOverwrtie?, regulation?) {
        let inList;
        if (regulation) {
            inList = this.selectedRegulations[regulation.name] === false ? 'extras' : 'exclusions';
        }
        if (toOverwrtie && inList) {
            this.domain.settings.data_protection.custom_ruleset[
                inList
            ] = this.domain.settings.data_protection.custom_ruleset[inList].filter((id) => {
                return !toOverwrtie.includes(id);
            });
        }
        this.infoTypes.forEach((infoType) => {
            infoType.enabled = this.domain.settings.data_protection.enabled_regulations.some((r) => {
                return infoType.regulations.includes(r);
            });

            const inExtras = this.domain.settings.data_protection.custom_ruleset.extras.includes(infoType.id);
            if (inExtras) {
                infoType.enabled = true;
            }

            const inExcludes = this.domain.settings.data_protection.custom_ruleset.exclusions.includes(infoType.id);
            if (inExcludes) {
                infoType.enabled = false;
            }
        });
    }

    toggleRegion (region) {
        region.pages.forEach((infoType) => {
            infoType.enabled = region.selectAll;
        });

        const ids = region.pages.map((i) => {
            return i.id;
        });

        if (region.selectAll) {
            // Remove ids from exclusions
            this.domain.settings.data_protection.custom_ruleset.exclusions = this.domain.settings.data_protection.custom_ruleset.exclusions.filter(id => !ids.includes(id));
            // Add unique ids to extras
            const newExtras = [...this.domain.settings.data_protection.custom_ruleset.extras, ...ids];
            this.domain.settings.data_protection.custom_ruleset.extras = [...new Set(newExtras)];
        } else {
            // Remove ids from extras
            this.domain.settings.data_protection.custom_ruleset.extras = this.domain.settings.data_protection.custom_ruleset.extras.filter(id => !ids.includes(id));
            // Add unique ids to exclusions
            const newExclusions = [...this.domain.settings.data_protection.custom_ruleset.exclusions, ...ids];
            this.domain.settings.data_protection.custom_ruleset.exclusions = [...new Set(newExclusions)];
        }
        this.isDisabled();
    }

    toggleExtraExclude (infoType, region) {
        if (infoType.enabled) {
            // Remove from extras
            const extrasIndex = this.domain.settings.data_protection.custom_ruleset.extras.indexOf(infoType.id);
            if (extrasIndex > -1) {
                this.domain.settings.data_protection.custom_ruleset.extras.splice(extrasIndex, 1);
            }
            this.domain.settings.data_protection.custom_ruleset.exclusions.push(infoType.id);
        } else {
            // Remove from exclusions
            const exclusionsIndex = this.domain.settings.data_protection.custom_ruleset.exclusions.indexOf(infoType.id);
            if (exclusionsIndex > -1) {
                this.domain.settings.data_protection.custom_ruleset.exclusions.splice(exclusionsIndex, 1);
            }
            this.domain.settings.data_protection.custom_ruleset.extras.push(infoType.id);
        }
        infoType.enabled = !infoType.enabled;
        const allSelected = region.pages.every((i) => {
            return i.enabled === true;
        });
        if (allSelected) {
            region.selectAll = true;
        } else {
            region.selectAll = false;
        }
        this.isDisabled();
        if (!deepEqual(this.originalCustomRuleset, this.domain.settings.data_protection.custom_ruleset)) {
            FormUtils.markFormAsDirty(this.dpmForm);
        }
    }
    isDisabled () {
        this.disabled = !this.filteredPages.some((page) => {
            return page.pages.some((infoType) => {
                return infoType.enabled === true;
            });
        });
    }
    submit ($event) {
        this.saving = true;
        FormUtils.markFormAsPristine(this.dpmForm);
        if (this.domain.id > 0) {
            this.ng2DomainRepoService.update(this.domain.id, {
                settings: { data_protection: this.domain.settings.data_protection },
            }).then((response) => {
                if (response) {
                    this.close(this.domain.settings.data_protection);
                }
            });
        } else {
            this.close(this.domain.settings.data_protection);
        }
    }
    close (val) {
        this.monDialog.close(this.monDialogId, val);
    }

    getGroupTooltip (text) {
        return this.ng2DataPrivacyService.formatText(text || 'other');
    }

    formatText (text) {
        return this.ng2DataPrivacyService.formatText(text || 'other');
    }
}
